/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDetailOrderDetailGoodsVo } from './OrderDetailOrderDetailGoodsVo';
import {
    OrderDetailOrderDetailGoodsVoFromJSON,
    OrderDetailOrderDetailGoodsVoFromJSONTyped,
    OrderDetailOrderDetailGoodsVoToJSON,
    OrderDetailOrderDetailGoodsVoToJSONTyped,
} from './OrderDetailOrderDetailGoodsVo';

/**
 * 
 * @export
 * @interface ResponseOrderDetailOrderDetailGoodsVo
 */
export interface ResponseOrderDetailOrderDetailGoodsVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderDetailOrderDetailGoodsVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderDetailOrderDetailGoodsVo
     */
    message?: string;
    /**
     * 
     * @type {OrderDetailOrderDetailGoodsVo}
     * @memberof ResponseOrderDetailOrderDetailGoodsVo
     */
    data?: OrderDetailOrderDetailGoodsVo;
}

/**
 * Check if a given object implements the ResponseOrderDetailOrderDetailGoodsVo interface.
 */
export function instanceOfResponseOrderDetailOrderDetailGoodsVo(value: object): value is ResponseOrderDetailOrderDetailGoodsVo {
    return true;
}

export function ResponseOrderDetailOrderDetailGoodsVoFromJSON(json: any): ResponseOrderDetailOrderDetailGoodsVo {
    return ResponseOrderDetailOrderDetailGoodsVoFromJSONTyped(json, false);
}

export function ResponseOrderDetailOrderDetailGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderDetailOrderDetailGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderDetailOrderDetailGoodsVoFromJSON(json['data']),
    };
}

export function ResponseOrderDetailOrderDetailGoodsVoToJSON(json: any): ResponseOrderDetailOrderDetailGoodsVo {
    return ResponseOrderDetailOrderDetailGoodsVoToJSONTyped(json, false);
}

export function ResponseOrderDetailOrderDetailGoodsVoToJSONTyped(value?: ResponseOrderDetailOrderDetailGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderDetailOrderDetailGoodsVoToJSON(value['data']),
    };
}

